/**
 * CSS `right` inset for fixed panels that clear the shell context drawer.
 * `ShellDrawer` writes `--shell-drawer-inset` on `documentElement`: the push width
 * while the drawer is open on lg+, otherwise `0px`. Fixed descendants pick the
 * variable up without re-rendering on each drag frame.
 */
export function useShellDrawerContentRight(): string {
  return "var(--shell-drawer-inset, 0px)"
}
